import { api } from '../../api/client';

export type BackupStatus = 'running' | 'ok' | 'failed';
export type BackupKind = 'scheduled' | 'manual' | 'drill';

export interface BackupRun {
  id: string;
  kind: BackupKind;
  status: BackupStatus;
  started_at: string;
  finished_at: string | null;
  media_snapshot: string | null;
  database_snapshot: string | null;
  dump_bytes: number | null;
  checked_at: string | null;
  message: string | null;
}

export interface BackupHealth {
  last_success_at: string | null;
  stale: boolean;
  age_hours: number | null;
  last_status: BackupStatus | null;
  last_message: string | null;
  stale_after_hours: number;
}

export interface BackupState {
  health: BackupHealth;
  runs: BackupRun[];
}

export const backupState = (limit = 20) => api.get<BackupState>(`/system/backups?limit=${limit}`);
